"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidMonthIndex = isValidMonthIndex;
exports.ShortMonths = exports.FullMonths = exports.ShortDays = exports.FullDays = exports.MonthOfYear = exports.DayOfWeek = exports.Months = exports.Days = void 0;

var _FullDays, _ShortDays, _FullMonths, _ShortMonths;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// a.k.a. day id
var Days; // a.k.a. month id

exports.Days = Days;

(function (Days) {
  Days["SUN"] = "sun";
  Days["MON"] = "mon";
  Days["TUE"] = "tue";
  Days["WED"] = "wed";
  Days["THU"] = "thu";
  Days["FRI"] = "fri";
  Days["SAT"] = "sat";
})(Days || (exports.Days = Days = {}));

var Months;
exports.Months = Months;

(function (Months) {
  Months["JAN"] = "jan";
  Months["FEB"] = "feb";
  Months["MAR"] = "mar";
  Months["APR"] = "apr";
  Months["MAY"] = "may";
  Months["JUN"] = "jun";
  Months["JUL"] = "jul";
  Months["AUG"] = "aug";
  Months["SEP"] = "sep";
  Months["OCT"] = "oct";
  Months["NOV"] = "nov";
  Months["DEC"] = "dec";
})(Months || (exports.Months = Months = {}));

var DayOfWeek = {
  0: Days.SUN,
  1: Days.MON,
  2: Days.TUE,
  3: Days.WED,
  4: Days.THU,
  5: Days.FRI,
  6: Days.SAT
};
exports.DayOfWeek = DayOfWeek;
var MonthOfYear = {
  0: Months.JAN,
  1: Months.FEB,
  2: Months.MAR,
  3: Months.APR,
  4: Months.MAY,
  5: Months.JUN,
  6: Months.JUL,
  7: Months.AUG,
  8: Months.SEP,
  9: Months.OCT,
  10: Months.NOV,
  11: Months.DEC
};
exports.MonthOfYear = MonthOfYear;

function isValidMonthIndex(idx) {
  return !!MonthOfYear[idx];
}

var FullDays = (_FullDays = {}, _defineProperty(_FullDays, Days.SUN, 'Sunday'), _defineProperty(_FullDays, Days.MON, 'Monday'), _defineProperty(_FullDays, Days.TUE, 'Tuesday'), _defineProperty(_FullDays, Days.WED, 'Wednesday'), _defineProperty(_FullDays, Days.THU, 'Thursday'), _defineProperty(_FullDays, Days.FRI, 'Friday'), _defineProperty(_FullDays, Days.SAT, 'Saturday'), _FullDays);
exports.FullDays = FullDays;
var ShortDays = (_ShortDays = {}, _defineProperty(_ShortDays, Days.SUN, 'Sun'), _defineProperty(_ShortDays, Days.MON, 'Mon'), _defineProperty(_ShortDays, Days.TUE, 'Tue'), _defineProperty(_ShortDays, Days.WED, 'Wed'), _defineProperty(_ShortDays, Days.THU, 'Thr'), _defineProperty(_ShortDays, Days.FRI, 'Fri'), _defineProperty(_ShortDays, Days.SAT, 'Sat'), _ShortDays);
exports.ShortDays = ShortDays;
var FullMonths = (_FullMonths = {}, _defineProperty(_FullMonths, Months.JAN, 'January'), _defineProperty(_FullMonths, Months.FEB, 'February'), _defineProperty(_FullMonths, Months.MAR, 'March'), _defineProperty(_FullMonths, Months.APR, 'April'), _defineProperty(_FullMonths, Months.MAY, 'May'), _defineProperty(_FullMonths, Months.JUN, 'June'), _defineProperty(_FullMonths, Months.JUL, 'July'), _defineProperty(_FullMonths, Months.AUG, 'August'), _defineProperty(_FullMonths, Months.SEP, 'September'), _defineProperty(_FullMonths, Months.OCT, 'October'), _defineProperty(_FullMonths, Months.NOV, 'November'), _defineProperty(_FullMonths, Months.DEC, 'December'), _FullMonths);
exports.FullMonths = FullMonths;
var ShortMonths = (_ShortMonths = {}, _defineProperty(_ShortMonths, Months.JAN, 'Jan'), _defineProperty(_ShortMonths, Months.FEB, 'Feb'), _defineProperty(_ShortMonths, Months.MAR, 'Mar'), _defineProperty(_ShortMonths, Months.APR, 'Apr'), _defineProperty(_ShortMonths, Months.MAY, 'May'), _defineProperty(_ShortMonths, Months.JUN, 'June'), _defineProperty(_ShortMonths, Months.JUL, 'July'), _defineProperty(_ShortMonths, Months.AUG, 'Aug'), _defineProperty(_ShortMonths, Months.SEP, 'Sept'), _defineProperty(_ShortMonths, Months.OCT, 'Oct'), _defineProperty(_ShortMonths, Months.NOV, 'Nov'), _defineProperty(_ShortMonths, Months.DEC, 'Dec'), _ShortMonths);
exports.ShortMonths = ShortMonths;